import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
	Button,
	Container,
	Title,
	TextInput,
	Alert,
	Paper,
	Space,
	Center,
} from '@mantine/core'
import { AlertCircle } from 'tabler-icons-react'

const ForgotPasswordPage = () => {
	const [email, setEmail] = useState('')
	const [status, setStatus] = useState(null)
	const [error, setError] = useState(null)
	const [loading, setLoading] = useState(false)

	const navigate = useNavigate()

	const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

	const handleSubmit = async () => {
		setLoading(true)
		setError(null)
		setStatus(null)

		try {
			const res = await fetch(`${BASE_URL}/auth/forgot-password`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email }),
			})

			const data = await res.json()

			if (!res.ok) {
				if (data.code === 'GOOGLE_ACCOUNT') {
					setError(
						'This email is linked to a Google account. Please use “Continue with Google” instead of resetting your password.'
					)
				} else {
					setError(data.message || 'Something went wrong.')
				}
			} else {
				setStatus(
					'If that email exists in our system, we sent you a reset link.'
				)
			}
		} catch (err) {
			setError('Network error, please try again.')
		} finally {
			setLoading(false)
		}
	}

	return (
		<Container size='xs'>
			<Center style={{ height: '100vh' }}>
				<Paper withBorder shadow='sm' p='xl' radius='md' w='100%'>
					<Title order={2} align='center'>
						Forgot Password
					</Title>
					<Space h='lg' />
					<TextInput
						label='Email'
						type='email'
						value={email}
						onChange={(e) => setEmail(e.currentTarget.value)}
					/>
					<Space h='md' />
					{error && (
						<Alert
							icon={<AlertCircle size={16} />}
							color='red'
							title='Error'
							mb='sm'
						>
							{error}
						</Alert>
					)}
					{status && (
						<Alert color='green' title='Success' mb='sm'>
							{status}
						</Alert>
					)}
					<Button fullWidth loading={loading} onClick={handleSubmit}>
						Send Reset Link
					</Button>
					<Space h='lg' />
					<Button
						fullWidth
						variant='outline'
						onClick={() => navigate('/login')}
						mb='sm'
					>
						Back to Login
					</Button>
				</Paper>
			</Center>
		</Container>
	)
}

export default ForgotPasswordPage
